import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import SearchForm from './SearchForm';
import LFMap from './LFMap';
import firebaseManager from '../Services/firebaseManager';
import { GoogleApiWrapper } from 'google-maps-react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AddFloatingButton from './AddFloatingButton';
import AddLfItemDialog from './AddLfItemDialog';
import AlertDialog from './AlertDialog';
import {green400 } from 'material-ui/styles/colors';
import {lfGreen, lfTan} from './lfColors.js';
import getMuiTheme from 'material-ui/styles/getMuiTheme';


const muiTheme = getMuiTheme({
  palette: {
    primary1Color: lfGreen[300],
    accent1Color: lfGreen[400],
    pickerHeaderColor: green400,
    color:lfTan[100],
  },
  menuItem: {
    selectedTextColor: green400,
  },
});

class LFMapContainer extends Component {


 

  state = {
   
    lfItems: [],

    // newItem is used when a user clicks on the Add button, and then in the
    // add dialog selects 'I will click on the map'.   newItem stores the data
    // for the item they want to add.
    addNewItem : false,
    newItem : {
      contactName:"",
      contactEmailAddress:"",
      contactPhoneNumber:"",
      creationTime:new Date(),
      extraInformation:"",
      lfType:0,
      name:"",
      reward:"",
      status:1,
      filename:"",
      lat:0.0,
      lng:0.0
    },

    // initItem is used when a user clicks on the map, and creates a new
    // marker.  The item is in the init state.   If they click on the marker,
    // the add dialog appears where they can add the rest of the item data.
    initItem : {
      contactName:"",
      contactEmailAddress:"",
      contactPhoneNumber:"",
      creationTime:new Date(),
      extraInformation:"",
      lfType:0,
      name:"",
      reward:"",
      status:1,
      filename:"",
      lat:0.0,
      lng:0.0
    },


    viewItem : {
      contactName:"",
      contactEmailAddress:"",
      contactPhoneNumber:"",
      creationTime:new Date(),
      extraInformation:"",
      lfType:0,
      name:"",
      reward:"",
      status:1,
      filename:"",
      lat:0.0,
      lng:0.0
    },

   

    isPerformingSearch:false,
    searchFilters : {
      searchRadiusMiles : 5,
      lfType : 0,
      status : 1
    },

    // indications if AddLFItemDialog is open
    open: false,




    alertOpen: false,
    alertTitle: "",
    alertMessage: "",
  }


  getAllItems = () => {
    firebaseManager.getAllItems( 
      this.props.fbDb,

      // Callback
      function( lfItems ){
        if( lfItems != null ){

          this.setState({
            lfItems: lfItems          
          });
        }
      }.bind(this)
    );
  }
  componentDidMount = ()=> {
    this.getAllItems();
  }

  componentWillUnmount() {
    this.props.fbDb.off();
  };

  onRequestShowAddDialog = ( lfItem ) => {
    this.setState({open: true,
      initItem:lfItem
    });
  }

  displayAlert( msg ){
    this.setState({
      alertOpen: true,
      alertMessage:msg});
  } 

  handleAlertClose = () => {
    this.setState({alertOpen: false});
  };

  /* Add dialog cancel */
  handleCancel = () => {
    this.setState({open: false});
  };




  

  handleMapClick = ( latLng ) => {
   
    if( this.state.isPerformingSearch ){

      this.setState({ isPerformingSearch:false});

      this.advancedSearch( latLng.lat(), latLng.lng(), 
        this.state.searchFilters.searchRadiusMiles, 
        this.state.searchFilters.lfType, 
        this.state.searchFilters.status );

    }
    else if( this.state.addNewItem ){
      let data = this.state.newItem;
      data.lat=latLng.lat();
      data.lng=latLng.lng();
      this.setState( {addNewItem:false});
      this.addItem( data, this.state.file );
 
    }
    else{
      /* User clicked on the map to add a new marker */
      /* add an initialized marker */
      let lfItem = 
        { 
          status:0,    // init state       
          name: "",
          creationTime : new Date().getTime(),
          lfType:0,
          extraInformation:"",
          reward:"",
          contactName:"",
          contactEmailAddress:"",
          contactPhoneNumber:"",
          filename:"",
          lat:latLng.lat(),
          lng:latLng.lng()
        }
  
   
        /* Copy the array, because LFMap props.lfItems array is a reference
          to this.state.lfItems.   lfItem was being pushed to this.state.lfItems,
          which caused LFMap to not re-render because it does a test to compare
          previous props with new props, and it looked like it was already updated. */ 
        var newLfItems=[...this.state.lfItems];
        newLfItems.push( lfItem );
        this.setState({
          lfItems:newLfItems          
        });

     }
  }


  advancedSearch( lat, lng, searchRadiusMiles, lfType, status ) {
    firebaseManager.advancedSearch( this.props.geofireRef,
      this.props.fbDb,
      lat,
      lng,
      searchRadiusMiles,
      lfType,
      status,
      function( lfItems ){
        if( lfItems != null ){
          this.setState({
            lfItems: lfItems          
          });
        }
        else{
          this.displayAlert( "Sorry!  No pets were found for your search criteria.  Try widening the search distance.");
        }
      }.bind(this)
    );
  }

  

  handleSearch = ( useCurrentLocation, status, lfType, searchRadiusMiles ) => {
    if( useCurrentLocation ){
      if (navigator && navigator.geolocation) {

        navigator.geolocation.getCurrentPosition((pos) => {
            this.advancedSearch( pos.coords.latitude, pos.coords.longitude,
              searchRadiusMiles, lfType, status );
         })
      }
      else{
        // console.log( "componentDidMount.  no navigator" );
      }
    }
    else{
      // the next time user clicks on map, do a search
      this.setState({isPerformingSearch:true});
    }
  }


  addItem = ( data, file ) =>{
      /* Add lfItem to firebase database */

      let key = this.props.fbDb.child('lfitems').push(data).key;
  
      /* Upload the image file to firebase storage */
      if( data.filename.length > 0 ){
        firebaseManager.uploadFile( this.props.fbStorageRef, data.filename, file );
      }

      /* Add lfItem to Geofire */
      firebaseManager.addItemToGeofire(this.props.geofireRef, key, data);

      /* Refresh the list by reloading from Firebase */
      this.getAllItems();

  }


  handleAdd = (useCurrentLocation, locationIsSet, file, data) => {
    this.setState({open: false});
    if( locationIsSet ){
      /* user already clicked on the map, so lat, lng were already set. */
      this.addItem( data, file );
    }
    else{

      /* User clicked on the Add button */
      if( useCurrentLocation ){
 
        if (navigator && navigator.geolocation) {

          navigator.geolocation.getCurrentPosition((pos) => {
              data.lat=pos.coords.latitude;
              data.lng=pos.coords.longitude;
              this.addItem( data, file );
          })
        }
        else{
          // console.log( "componentDidMount.  no navigator" );
        }
      }
      else{
         this.setState({
          addNewItem:true,
          file:file,
          newItem:{
            contactEmailAddress : data.contactEmailAddress,
            contactName : data.contactName,
            contactPhoneNumber : data.contactPhoneNumber,
            name : data.name,
            extraInformation : data.extraInformation,
            reward : data.reward,
            creationTime : data.creationTime,
            lfType:data.lfType,
            status:data.status,
            filename:data.filename
        }, });
      }

      
    }
 
  };

  

  render() {   
    return (
      <div className="LFMapContainer">


        {/* header row */}
        <div className="headerRow">  
         {/*
        <div><img className="pawImg" src="paw_large.png" width="80" height="80"/> </div>    
            <div><h1>Lost and Found Pets</h1></div>
         */}
          <p className="headerParagraph">
            <img className="pawImg" src="logo.png" width="100" height="100"/>
            <h1>Lost and Found Pets</h1> 

          </p> 
        </div>
         
        

        {/* content row */}
        <div className="wrapper">
    
          <SearchForm handleSearch={this.handleSearch } 
            handleClearSearch={function(){
              this.setState({isPerformingSearch:false});
              firebaseManager.getAllItems( 
                this.props.fbDb,
                function( lfItems ){
                  if( lfItems != null ){
                    this.setState({
                      lfItems: lfItems          
                    });
                  }
                }.bind(this)
              );
          
            }.bind(this)}/>
          

            <div className="mapWrapperOuter" >
              <div className="mapWrapperInner">
            
                <Route path="/" render={(props) => <LFMap 
                  fbStorageRef={this.props.fbStorageRef}
                  google={this.props.google} 
                  lfItems={this.state.lfItems} 
                  handleMapClick={this.handleMapClick}
                  onRequestShowAddDialog={this.onRequestShowAddDialog}
                  {...props}/>}/>

              </div>
              
              <div className="addButtonWrapper">
                <MuiThemeProvider muiTheme={muiTheme}>
                  <AddFloatingButton onRequestShowAddDialog={
                    this.onRequestShowAddDialog}/>
                </MuiThemeProvider>

              </div>

          </div>
       



 




        <MuiThemeProvider>
           <AddLfItemDialog handleAdd={this.handleAdd} 
            handleCancel={this.handleCancel} 
            open={this.state.open}
            fbDb = {this.props.fbDb}
            initItem = {this.state.initItem}
            className="addLFItem"
            />
        </MuiThemeProvider>

       

        <MuiThemeProvider>
           <AlertDialog 
            message={this.state.alertMessage} 
            open={this.state.alertOpen}
            handleAlertClose={this.handleAlertClose}
            className="dlgAlert"
            />
        </MuiThemeProvider>

        </div>

        {/* footer row */}
        <div className="footerRow">        
          
        </div>

      </div>  



    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyBS-Uh-B6bld2aqpcg_tyZybLgb6zbUh1Q',
  libraries: ['visualization']
})(LFMapContainer)



// WEBPACK FOOTER //
// ./src/Components/LFMapContainer.js